@if (saleHasDocuments) {
    <div class="tw:mb-6">
        <h6 class="tw:h6 mb-4">{{ 'SALE_DETAILS.documents' | translate }}</h6>
        @for (saleGroup of saleDocuments(); track saleGroup.invoiceId) {
            <div class="tw:mb-4 tw:rounded-lg tw:bg-neutral-100 tw:px-4 tw:py-3">
                <div class="tw:text-primary-500 tw:mb-2 tw:font-bold tw:text-sm tw:flex tw:items-center tw:justify-between">
                    <div>{{'GENERAL.invoice' | translate}} {{ saleGroup.invoiceReference }}</div>
                    <div>
                        @if (saleGroup.amount !== sale.total) {
                            <span class="tw:text-neutral-500">{{ 'SALE_DETAILS.partialInvoice' | translate }}</span>
                        }
                    </div>
                </div>
                @for (document of saleGroup.documents; track `${document.documentType}-${document.id}`) {
                    @if (document.invoicePdfUrl || document.receiptPdfUrl || document.pdfUrl) {
                        <div class="tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-white tw:p-4 tw:mb-2">
                            <div class="tw:flex tw:items-center tw:gap-3">
                                <app-icon
                                    icon="receipt"
                                    [extraClass]="
                                        document.documentType === SaleDetailsDocumentType.CREDITNOTE ? 'tw:!text-error-400' : 'tw:!text-primary-500'
                                    "
                                />

                                <div class="tw:ml-2 tw:text-sm">
                                    @if (document.documentType === SaleDetailsDocumentType.INVOICE) {
                                        {{'GENERAL.invoice' | translate}} {{ document.invoiceReference || '-' }}
                                    } @else if (document.documentType === SaleDetailsDocumentType.PAYMENT) {
                                        {{'GENERAL.receipt' | translate}} {{ document.receiptReference || '-' }}
                                    } @else if (document.documentType === SaleDetailsDocumentType.CREDITNOTE) {
                                        {{'GENERAL.creditNote' | translate}} {{ document.reference || '-' }}
                                    }
                                    <div class="tw:text-neutral-500">
                                        {{ document.createdAt | date: 'dd/MM/yyyy' }}@if (document.amount) { · {{ document.amount | merchantCurrency }} }
                                    </div>
                                </div>
                            </div>

                            <div class="tw:flex tw:items-center tw:gap-2 tw:text-sm tw:font-semibold">

                                @if (document.documentType === SaleDetailsDocumentType.INVOICE) {
                                    @if (document.invoicePdfUrl) {
                                        <app-button
                                            type="transparent"
                                            extraClass="tw:!p-0"
                                            (clickEvent)="downloadInvoice(document.invoicePdfUrl, document.invoiceReference)"
                                        >
                                            <app-icon icon="file_download" extraClass="tw:!text-primary-500" />
                                        </app-button>
                                    }
                                    <app-button type="transparent" extraClass="tw:!p-0 tw:ml-2" (clickEvent)="emailInvoice(document.id)">
                                        <app-icon icon="mail_outline" extraClass="tw:!text-primary-500" />
                                    </app-button>
                                } @else if (document.documentType === SaleDetailsDocumentType.PAYMENT) {
                                    <app-button
                                        type="transparent"
                                        extraClass="tw:!p-0"
                                        (clickEvent)="downloadInvoice(document.receiptPdfUrl, document.receiptReference)"
                                    >
                                        <app-icon icon="file_download" extraClass="tw:!text-primary-500" />
                                    </app-button>
                                    <app-button type="transparent" extraClass="tw:!p-0 tw:ml-2" (clickEvent)="emailReceipt(document.id)">
                                        <app-icon icon="mail_outline" extraClass="tw:!text-primary-500" />
                                    </app-button>
                                } @else if (document.documentType === SaleDetailsDocumentType.CREDITNOTE) {
                                    <app-button
                                        type="transparent"
                                        extraClass="tw:!p-0"
                                        (clickEvent)="downloadInvoice(document.pdfUrl, document.reference)"
                                    >
                                        <app-icon icon="file_download" extraClass="tw:!text-primary-500" />
                                    </app-button>
                                    <app-button type="transparent" extraClass="tw:!p-0 tw:ml-2" (clickEvent)="emailCreditNote(document.id)">
                                        <app-icon icon="mail_outline" extraClass="tw:!text-primary-500" />
                                    </app-button>
                                }
                            </div>
                        </div>
                    }
                }
            </div>
        }
    </div>
}
